import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import APIError from 'types/api_error';

import { useAPI } from 'hooks/api/useAPI';

type RemoveUserGroupMembersParams = {
  groupId: string;
  account_ids: string[];
};

export function useRemoveUserGroupMembers({
  onSettled,
  ...options
}: UseMutationOptions<void, APIError, RemoveUserGroupMembersParams> = {}) {
  const queryClient = useQueryClient();
  const { applicationID, client } = useAPI();

  return useMutation(
    async ({ groupId, account_ids }) => {
      await client.delete(
        `/apps/${applicationID}/user_groups/${groupId}/members`,
        { params: { 'account_ids[]': account_ids } }
      );
    },
    {
      ...options,
      onSettled(...args) {
        onSettled?.(...args);
        queryClient.invalidateQueries(['user-group-members']);
        queryClient.invalidateQueries(['user-groups']);
      },
    }
  );
}
